import api from "../../../../../api/api"


const getByProposalId = (proposalId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/proposal-item/"+proposalId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const save = (payload) => {
    return new Promise((resolve, reject) => {
        api.post("erp/proposal-item", payload).then((res) => {
            if (!res.data.error) {
                resolve(res.data);
            } else {
                reject({ msg: res.data.msg });
            }
        }).catch((error) => {
            reject({ msg: "Something Went Wrong", error });
        });
    });
};

const update = (payload) => {
    return new Promise((resolve, reject) => {
        api.put("erp/proposal-item", payload).then((res) => {
            if (!res.data.error) {
                resolve(res.data);
            } else {
                reject({ msg: res.data.msg });
            }
        }).catch((error) => {
            reject({ msg: "Something Went Wrong", error });
        });
    });
};

const remove = (id) => {
    return new Promise((resolve, reject) => {
        api.delete("erp/proposal-item/" + id).then((res) => {
            if (!res.data.error) {
                resolve(res);
            } else {
                reject({ msg: res.data.msg });
            }
        }).catch((error) => {
            reject({ msg: "Something Went Wrong", error });
        });
    });
};

const pproposalItemServices = {
    getByProposalId,
    save,
    update,
    remove,
};

export default pproposalItemServices;